export default __webpack_public_path__ + "static/media/sublist.01268913.svg";